module.exports = __webpack_public_path__ + "static/media/invalido.9bbf6d8c.png";